<div class="ui-g price-details-container">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title">
      <div
        *ngIf="showJobs() && showOrders() && jobOrderPriceSummary.items"
        class="ui-grid-row summary-table-div"
      >
        <div class="ui-grid-row">
          <div class="ui-g-8">
            <h3>Profit / Loss Report</h3>
          </div>
          <div class="ui-g-4">
            <button
              type="button"
              class="btn-to-right red-btn"
              (click)="back()"
              style="margin-top: 10px; margin-bottom: 20px"
              label="Back"
              pButton
            ></button>
            <button
              *ngIf="organisationTypeId == 1"
              type="button"
              class="btn-to-right"
              (click)="syncExpenses()"
              [disabled]="syncExpensesLoading"
              style="margin-top: 10px; margin-bottom: 10px"
              label="Sync Expenses"
              pButton
            ></button>
          </div>
        </div>

        <p-table [value]="jobOrderPriceSummary.items">
          <ng-template pTemplate="header">
            <tr>
              <th colspan="2">Order</th>
              <th class="borderless"></th>
              <th colspan="2">Income(£)</th>
              <th class="borderless"></th>
              <th colspan="2">Expenses(£)</th>
              <th class="borderless"></th>
              <th colspan="2">P/L(£)</th>
            </tr>
            <tr>
              <th pSortableColumn="orderNumber">Order#</th>
              <th pSortableColumn="vehicleReg">Task</th>
              <th class="borderless"></th>
              <th pSortableColumn="customerRevenue">Customer</th>
              <th pSortableColumn="engineiusRevenue">Engineius</th>
              <th class="borderless"></th>
              <th>Supplier</th>
              <th>Engineius</th>
              <th class="borderless"></th>
              <th>+/-</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.orderNumber != null ? row.orderNumber : 'Job Cost' }}</td>
              <td>{{ row.vehicleReg }}</td>
              <td class="borderless"></td>
              <td>{{ row.customerRevenue | number : '1.2-2' }}</td>
              <td>{{ row.engineiusRevenue | number : '1.2-2' }}</td>
              <td class="borderless"></td>
              <td>{{ row.supplierExpense | number : '1.2-2' }}</td>
              <td>{{ row.engineiusExpense | number : '1.2-2' }}</td>
              <td class="borderless"></td>
              <td>
                <span
                  *ngIf="row.vehicleReg"
                  [ngClass]="
                    row.customerRevenue +
                      row.engineiusRevenue -
                      (row.supplierExpense + row.engineiusExpense) <
                    0
                      ? 'red'
                      : 'green'
                  "
                >
                  {{
                    row.customerRevenue +
                      row.engineiusRevenue -
                      (row.supplierExpense + row.engineiusExpense) | number : '1.2-2'
                  }}
                </span>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr>
              <td colspan="2"></td>
              <td class="borderless"></td>
              <td class="green">
                {{ jobOrderPriceSummary.totalCustomerRevenue | number : '1.2-2' }}
              </td>
              <td class="green">
                {{ jobOrderPriceSummary.totalEngineiusRevenue | number : '1.2-2' }}
              </td>
              <td class="borderless"></td>
              <td class="red">
                {{ jobOrderPriceSummary.totalSupplierExpense | number : '1.2-2' }}
              </td>
              <td class="red">
                {{ jobOrderPriceSummary.totalEngineiusExpense | number : '1.2-2' }}
              </td>
              <td class="borderless"></td>
              <td [class]="jobOrderPriceSummary.profitLoss < 0 ? 'red' : 'green'">
                {{ jobOrderPriceSummary.profitLoss | number : '1.2-2' }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!--- DATATABLE DEPRECATED ----

        <p-dataTabl [value]="jobOrderPriceSummary.items">
          <p-headerColumnGroup>
            <p-row>
              <p-column header="Order" colspan="2"></p-column>
              <p-column header="" styleClass="borderless"></p-column>
              <p-column header="Income(£)" colspan="2"></p-column>
              <p-column header="" styleClass="borderless"></p-column>
              <p-column header="Expenses(£)" colspan="2"></p-column>
              <p-column header="" styleClass="borderless"></p-column>
              <p-column header="P/L(£)" colspan=""></p-column>
            </p-row>
            <p-row>
              <p-column header="Order#"></p-column>
              <p-column header="Task"></p-column>
              <p-column header="" styleClass="borderless"></p-column>
              <p-column header="Customer"></p-column>
              <p-column header="Engineius"></p-column>
              <p-column header="" styleClass="borderless"></p-column>
              <p-column header="Supplier"></p-column>
              <p-column header="Engineius"></p-column>
              <p-column header="" styleClass="borderless"></p-column>
              <p-column header="+/-" colspan=""></p-column>
            </p-row>
          </p-headerColumnGroup>

          <p-column field="orderNumber" styleClass="text-center" [sortable]="tru">
            <ng-template let-row="rowData" pTemplate="body">
              {{row.orderNumber != null ? row.orderNumber : 'Job Cost'}}
            </ng-template>
          </p-column>
          <p-column field="vehicleReg" styleClass="text-center" [sortable]="tru"></p-column>
          <p-column header="" styleClass="borderless" bodyStyleClass="no-bg" headerStyleClass="no-bg"></p-column>
          <p-column field="customerRevenue" styleClass="text-center green" [sortable]="tru">
            <ng-template let-row="rowData" pTemplate="body">
              {{row.customerRevenue | number :'1.2-2'}}
            </ng-template>
          </p-column>
          <p-column field="engineiusRevenue" styleClass="text-center green" [sortable]="tru">
            <ng-template let-row="rowData" pTemplate="body">
              {{row.engineiusRevenue | number :'1.2-2'}}
            </ng-template>
          </p-column>
          <p-column field="" styleClass="borderless" bodyStyleClass="no-bg" headerStyleClass="no-bg"
                    [sortable]="tru"></p-column>
          <p-column field="supplierExpense" styleClass="text-center red" [sortable]="tru">
            <ng-template let-row="rowData" pTemplate="body">
              {{row.supplierExpense | number :'1.2-2'}}
            </ng-template>
          </p-column>
          <p-column field="engineiusExpense" styleClass="text-center red" [sortable]="tru">
            <ng-template let-row="rowData" pTemplate="body">
              {{row.engineiusExpense | number :'1.2-2'}}
            </ng-template>
          </p-column>
          <p-column field="" styleClass="borderless" bodyStyleClass="no-bg" headerStyleClass="no-bg"
                    [sortable]="tru"></p-column>
          <p-column field="" styleClass="text-center" [sortable]="tru">
            <ng-template let-row="rowData" pTemplate="body">
                            <span *ngIf="row.vehicleReg"
                                  [ngClass]="((row.customerRevenue + row.engineiusRevenue) - (row.supplierExpense + row.engineiusExpense)) < 0 ? 'red' : 'green'">
                                {{((row.customerRevenue + row.engineiusRevenue) - (row.supplierExpense + row.engineiusExpense)) | number :'1.2-2'}}
                            </span>
            </ng-template>
          </p-column>

          <p-footerColumnGroup>
            <p-row>
              <p-column footer="Totals" colspan="2"></p-column>
              <p-column header="" styleClass="borderless"></p-column>
              <p-column styleClass="green"
                        footer="{{jobOrderPriceSummary.totalCustomerRevenue | number :'1.2-2'}}"></p-column>
              <p-column styleClass="green"
                        footer="{{jobOrderPriceSummary.totalEngineiusRevenue | number :'1.2-2'}}"></p-column>
              <p-column footer="" colspan="" styleClass="borderless"></p-column>
              <p-column styleClass="red"
                        footer="{{jobOrderPriceSummary.totalSupplierExpense | number :'1.2-2'}}"></p-column>
              <p-column styleClass="red"
                        footer="{{jobOrderPriceSummary.totalEngineiusExpense | number :'1.2-2'}}"></p-column>
              <p-column footer="" colspan="" styleClass="borderless"></p-column>
              <p-column [styleClass]="jobOrderPriceSummary.profitLoss < 0 ? 'red' : 'green'"
                        footer="{{jobOrderPriceSummary.profitLoss | number :'1.2-2'}}"></p-column>
            </p-row>
          </p-footerColumnGroup>
        </p-dataTable>

        --->
      </div>

      <div *ngIf="showJobs()" class="ui-grid-row mt-4">
        <p-card styleClass="prices-card">
          <div class="ui-grid-row">
            <div class="ui-g-8">
              <h3>Job Prices <span *ngIf="organisationTypeId == 1">(Supplier)</span></h3>
            </div>
            <div class="ui-g-4">
              <button
                type="button"
                class="btn-to-right red-btn"
                (click)="back()"
                *ngIf="showJobs() && !showOrders()"
                style="margin-top: 10px; margin-bottom: 20px"
                label="Back"
                pButton
              ></button>
              <button
                *ngIf="organisationTypeId == 1"
                type="button"
                class="btn-to-right"
                icon="fa fa-plus"
                (click)="addJob(transactionTypeKeys[supplierKey])"
                style="margin-top: 10px; margin-bottom: 10px"
                label="Job Price"
                pButton
              ></button>
            </div>
          </div>

          <p-table [value]="supplierPrices" [resizableColumns]="true">
            <ng-template pTemplate="header">
              <tr>
                <th pResizableColumn pSortableColumn="createdDateTime">Date</th>
                <th pResizableColumn pSortableColumn="order?.orderNumber">Order#</th>
                <th pResizableColumn pSortableColumn="accountCode">Account Code</th>
                <th pResizableColumn pSortableColumn="task?.vehicle?.registrationNumber">
                  Vehicle Reg
                </th>
                <th pResizableColumn pSortableColumn="description">Description</th>
                <th pResizableColumn pSortableColumn="amount">Amount</th>
                <th pResizableColumn pSortableColumn="supplierInvoice?.invoiceDate">
                  Invoice Date
                </th>
                <th pResizableColumn pSortableColumn="supplierInvoice?.inoviceNumber">
                  Invoice No
                </th>
                <th *ngIf="canModifyJobTransactionLine()"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{ row.createdDateTime | datex : 'ddd DD MMM YY HH:mm' }}</td>
                <td>{{ row.order?.orderNumber }}</td>
                <td>{{ row.accountCode }}</td>
                <td>{{ row.task?.vehicle?.registrationNumber }}</td>
                <td>{{ row.description }}</td>
                <td>{{ row.amount | number : '1.2-2' }}</td>
                <td>{{ row.supplierInvoice?.invoiceDate | datex : 'ddd DD MMM YY HH:mm' }}</td>
                <td>{{ row.supplierInvoice?.invoiceNumber }}</td>
                <td *ngIf="canModifyJobTransactionLine()">
                  <div
                    *ngIf="row.supplierInvoiceId == null && row.invoiceId == null"
                    [ngClass]="['text-center']"
                  >
                    <span
                      class="modify-transaction-line-ctrl"
                      (click)="modifyJobTransactionLine(row.id)"
                      >Modify</span
                    >
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- DATATABLE DEPRECATED --

          <p-dataTabl [value]="supplierPrices" [resizableColumns]="true">
            <p-column field="createdDateTime" header="Date" [style]="{'width': '15%'}" styleClass="text-center"
                      [sortable]="tru">
              <ng-template let-row="rowData" pTemplate="body">
                {{ row.createdDateTime |datex:'ddd DD MMM YY HH:mm' }}
              </ng-template>
            </p-column>
            <p-column field="orderNumber" header="Order#" pResizableColumn [style]="{'width': '10%'}"
                      styleClass="text-center" [sortable]="tru">
              <ng-template let-row="rowData" pTemplate="body">
                {{row.order?.orderNumber}}
              </ng-template>
            </p-column>
            <p-column field="accountCode" header="Account Code" pResizableColumn [style]="{'width': '10%'}"
                      styleClass="text-center"></p-column>
            <p-column field="vehicleReg" header="Vehicle Reg" pResizableColumn [style]="{'width': '10%'}"
                      styleClass="text-center">
              <ng-template let-row="rowData" pTemplate="body">
                {{row.task?.vehicle?.registrationNumber}}
              </ng-template>
            </p-column>
            <p-column field="description" header="Description" pResizableColumn [style]="{'width': '50%'}"></p-column>
            <p-column field="amount" header="Amount" pResizableColumn [style]="{'width': '15%'}"
                      styleClass="text-center">
              <ng-template let-row="rowData" pTemplate="body">
                {{row.amount | number :'1.2-2'}}
              </ng-template>
            </p-column>
            <p-column header="" [style]="{'width': '10%'}" *ngIf="canModifyJobTransactionLine()">
              <ng-template let-row="rowData" pTemplate="body">
                <div *ngIf="row.supplierInvoiceId == null && row.invoiceId == null" [ngClass]="['text-center']">
                  <span class="modify-transaction-line-ctrl" (click)="modifyJobTransactionLine(row.id)">Modify</span>
                </div>
              </ng-template>
            </p-column>
          </p-dataTable>

          -->

          <div align="right" class="summary-div">
            <span>Total: £{{ total(supplierPrices) }}</span>
          </div>
          <div *ngIf="showEngineiusJobPrices()">
            <div class="ui-grid-row">
              <div class="ui-g-8">
                <h3>Job Prices (Engineius)</h3>
              </div>
              <div class="ui-g-4">
                <button
                  *ngIf="organisationTypeId == 1"
                  type="button"
                  class="btn-to-right"
                  icon="fa fa-plus"
                  (click)="addJob(transactionTypeKeys[engineiusKey])"
                  style="margin-top: 10px; margin-bottom: 10px"
                  label="Engineius Price"
                  pButton
                ></button>
              </div>
            </div>

            <p-table [value]="engSupplierPrices" [resizableColumns]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th pResizableColumn pSortableColumn="createdDateTime">Date</th>
                  <th pResizableColumn pSortableColumn="order?.orderNumber">Order#</th>
                  <th pResizableColumn pSortableColumn="accountCode">Account Code</th>
                  <th pResizableColumn pSortableColumn="task?.vehicle?.registrationNumber">
                    Vehicle Reg
                  </th>
                  <th pResizableColumn pSortableColumn="description">Description</th>
                  <th pResizableColumn pSortableColumn="amount">Amount</th>
                  <th></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>{{ row.createdDateTime | datex : 'ddd DD MMM YY HH:mm' }}</td>
                  <td>{{ row.order?.orderNumber }}</td>
                  <td>{{ row.accountCode }}</td>
                  <td>{{ row.task?.vehicle?.registrationNumber }}</td>
                  <td>{{ row.description }}</td>
                  <td>{{ row.amount | number : '1.2-2' }}</td>
                  <td *ngIf="canModifyJobTransactionLine()">
                    <div [ngClass]="['text-center']">
                      <span
                        class="modify-transaction-line-ctrl"
                        (click)="modifyJobTransactionLine(row.id)"
                        >Modify</span
                      >
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <!-- DATATABLE DEPRECATED ---

            <p-dataTabl [value]="engSupplierPrices" [resizableColumns]="true">
              <p-column field="createdDateTime" header="Date" [style]="{'width': '15%'}" styleClass="text-center"
                        [sortable]="tru">
                <ng-template let-row="rowData" pTemplate="body">
                  {{ row.createdDateTime |datex:'ddd DD MMM YY HH:mm' }}
                </ng-template>
              </p-column>
              <p-column field="orderNumber" header="Order#" pResizableColumn [style]="{'width': '10%'}"
                        styleClass="text-center" [sortable]="tru">
                <ng-template let-row="rowData" pTemplate="body">
                  {{row.order?.orderNumber}}
                </ng-template>
              </p-column>
              <p-column field="accountCode" header="Account Code" pResizableColumn [style]="{'width': '10%'}"
                        styleClass="text-center"></p-column>
              <p-column field="vehicleReg" header="Vehicle Reg" pResizableColumn [style]="{'width': '10%'}"
                        styleClass="text-center">
                <ng-template let-row="rowData" pTemplate="body">
                  {{row.task?.vehicle?.registrationNumber}}
                </ng-template>
              </p-column>
              <p-column field="description" header="Description" pResizableColumn [style]="{'width': '50%'}"></p-column>
              <p-column field="amount" header="Amount" pResizableColumn [style]="{'width': '15%'}"
                        styleClass="text-center">
                <ng-template let-row="rowData" pTemplate="body">
                  {{row.amount | number :'1.2-2'}}
                </ng-template>
              </p-column>
              <p-column header="" [style]="{'width': '10%'}" *ngIf="canModifyJobTransactionLine()">
                <ng-template let-row="rowData" pTemplate="body">
                  <div [ngClass]="['text-center']">
                    <span class="modify-transaction-line-ctrl" (click)="modifyJobTransactionLine(row.id)">Modify</span>
                  </div>
                </ng-template>
              </p-column>
            </p-dataTable>

            --->

            <div align="right" class="summary-div">
              <span>Total: £{{ total(engSupplierPrices) }}</span>
            </div>
          </div>
        </p-card>
      </div>

      <div *ngIf="showOrders()" ngClass="ui-grid-row mt-4">
        <p-card styleClass="prices-card">
          <div class="ui-grid-row">
            <div class="ui-grid-row">
              <div class="ui-g-8">
                <h3>Order Prices <span *ngIf="organisationTypeId == 1">(Customer)</span></h3>
              </div>
              <div class="ui-g-4">
                <div>
                  <button
                    *ngIf="!showJobs()"
                    type="button"
                    class="btn-to-right red-btn"
                    (click)="back()"
                    label="Back"
                    pButton
                    style="margin-top: 10px"
                  ></button>
                  <button
                    *ngIf="organisationTypeId == 1"
                    type="button"
                    class="btn-to-right"
                    (click)="addOrder(transactionTypeKeys[customerKey])"
                    icon="fa fa-plus"
                    label="Customer cost"
                    pButton
                    style="margin-top: 10px; margin-bottom: 20px"
                  ></button>
                </div>
              </div>
            </div>

            <p-table [value]="customerPrices" sortField="createdDateTime" [resizableColumns]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th pResizableColumn pSortableColumn="createdDateTime">Date</th>
                  <th pResizableColumn pSortableColumn="orderNumber">Order#</th>
                  <th pResizableColumn pSortableColumn="accountCode">Cost Code</th>
                  <th pResizableColumn pSortableColumn="task?.vehicle?.registrationNumber">
                    Vehicle Reg
                  </th>
                  <th pResizableColumn pSortableColumn="description">Description</th>
                  <th pResizableColumn pSortableColumn="amount">Amount</th>
                  <th pResizableColumn pSortableColumn="customerInvoice?.invoiceDate">
                    Invoice Date
                  </th>
                  <th pResizableColumn pSortableColumn="customerInvoice?.xeroInvoiceNumber">
                    Invoice No
                  </th>

                  <th *ngIf="canModifyOrderTransactionLine()"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>{{ row.createdDateTime | datex : 'ddd DD MMM HH:mm' }}</td>
                  <td>{{ row.orderNumber }}</td>
                  <td>{{ row.accountCode }}</td>
                  <td>{{ row.task?.vehicle?.registrationNumber }}</td>
                  <td>{{ row.description }}</td>
                  <td>{{ row.amount | number : '1.2-2' }}</td>
                  <td>{{ row.customerInvoice?.invoiceDate | datex : 'ddd DD MMM YY HH:mm' }}</td>
                  <td>{{ row.customerInvoice?.xeroInvoiceNumber }}</td>
                  <td *ngIf="canModifyOrderTransactionLine()">
                    <div
                      *ngIf="row.customerInvoiceId == null && row.invoiceId == null"
                      [ngClass]="['text-center']"
                    >
                      <span
                        class="modify-transaction-line-ctrl"
                        (click)="modifyOrderTransactionLine(row.id)"
                        >Modify</span
                      >
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <!--- DATATABLE DEPRECATED ----
            <p-dataTabl [value]="customerPrices" [sortField]="createdDateTime" [resizableColumns]="true">
              <p-column field="createdDateTime" header="Date" pResizableColumn [style]="{'width': '15%'}"
                        styleClass="text-center" [sortable]="tru">
                <ng-template let-row="rowData" pTemplate="body">
                  {{ row.createdDateTime |datex:'ddd DD MMM HH:mm' }}
                </ng-template>
              </p-column>
              <p-column field="orderNumber" header="Order#" pResizableColumn [style]="{'width': '10%'}"
                        styleClass="text-center" [sortable]="tru"></p-column>
              <p-column field="accountCode" header="Cost Code" pResizableColumn [style]="{'width': '10%'}"
                        styleClass="text-center"></p-column>
              <p-column field="vehicleReg" header="Vehicle Reg" pResizableColumn [style]="{'width': '10%'}"
                        styleClass="text-center">
                <ng-template let-row="rowData" pTemplate="body">
                  {{row.task?.vehicle?.registrationNumber}}
                </ng-template>
              </p-column>
              <p-column field="description" header="Description" pResizableColumn [style]="{'width': '50%'}"></p-column>
              <p-column field="purchaseOrderNumber" header="Purchase Order No" pResizableColumn
                        [style]="{'width': '15%'}" styleClass="text-center"></p-column>
              <p-column field="amount" header="Amount" pResizableColumn [style]="{'width': '15%'}"
                        styleClass="text-center">
                <ng-template let-row="rowData" pTemplate="body">
                  {{row.amount | number :'1.2-2'}}
                </ng-template>
              </p-column>
              <p-column header="" [style]="{'width': '10%'}" *ngIf="canModifyOrderTransactionLine()">
                <ng-template let-row="rowData" pTemplate="body">
                  <div *ngIf="row.customerInvoiceId == null && row.invoiceId == null" [ngClass]="['text-center']">
                    <span class="modify-transaction-line-ctrl"
                          (click)="modifyOrderTransactionLine(row.id)">Modify</span>
                  </div>
                </ng-template>
              </p-column>
            </p-dataTable>

            --->

            <div align="right" class="summary-div">
              <span>Total: £{{ total(customerPrices) }}</span>
            </div>
          </div>

          <div *ngIf="showEngineiusOrderPrices()">
            <div class="ui-grid-row">
              <div class="ui-g-8"><h3>Order Cost (Engineius)</h3></div>
              <div class="ui-g-4">
                <button
                  *ngIf="organisationTypeId == 1"
                  type="button"
                  class="btn-to-right"
                  (click)="addOrder(transactionTypeKeys[engineiusKey])"
                  icon="fa fa-plus"
                  label="Engineius cost"
                  pButton
                  style="margin-top: 10px; margin-bottom: 10px"
                ></button>
              </div>
            </div>

            <p-table
              [value]="enginieusOrderPrices"
              [sortField]="createdDateTime"
              [resizableColumns]="true"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th pResizableColumn pSortableColumn="createdDateTime">Date</th>
                  <th pResizableColumn pSortableColumn="orderNumber">Order#</th>
                  <th pResizableColumn pSortableColumn="accountCode">Code Code</th>
                  <th pResizableColumn pSortableColumn="task?.vehicle?.registrationNumber">
                    Vehicle Reg
                  </th>
                  <th pResizableColumn pSortableColumn="description">Description</th>
                  <th pResizableColumn pSortableColumn="amount">Amount</th>
                  <th *ngIf="canModifyOrderTransactionLine()"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="order">
                  <td>{{ row.createdDateTime | datex : 'ddd DD MMM HH:mm' }}</td>
                  <td>{{ row.orderNumber }}</td>
                  <td>{{ row.accountCode }}</td>
                  <td>{{ row.task?.vehicle?.registrationNumber }}</td>
                  <td>{{ row.description }}</td>
                  <td>{{ row.amount | number : '1.2-2' }}</td>
                  <td *ngIf="canModifyOrderTransactionLine()">
                    <div [ngClass]="['text-center']">
                      <span
                        class="modify-transaction-line-ctrl"
                        (click)="modifyOrderTransactionLine(row.id)"
                        >Modify</span
                      >
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <!-- DATATABLE DEPRECATED ---

            <p-dataTabl [value]="enginieusOrderPrices" [sortField]="createdDateTime" [resizableColumns]="true">
              <p-column field="createdDateTime" header="Date" pResizableColumn [style]="{'width': '15%'}"
                        styleClass="text-center" [sortable]="tru">
                <ng-template let-row="rowData" pTemplate="body">
                  {{ row.createdDateTime |datex:'ddd DD MMM HH:mm' }}
                </ng-template>
              </p-column>
              <p-column field="orderNumber" header="Order#" pResizableColumn [style]="{'width': '10%'}"
                        styleClass="text-center" [sortable]="tru"></p-column>
              <p-column field="accountCode" header="Cost Code" pResizableColumn [style]="{'width': '10%'}"
                        styleClass="text-center"></p-column>
              <p-column field="vehicleReg" header="Vehicle Reg" pResizableColumn [style]="{'width': '10%'}"
                        styleClass="text-center">
                <ng-template let-row="rowData" pTemplate="body">
                  {{row.task?.vehicle?.registrationNumber}}
                </ng-template>
              </p-column>
              <p-column field="description" header="Description" pResizableColumn [style]="{'width': '50%'}"></p-column>
              <p-column field="purchaseOrderNumber" header="Purchase Order No" pResizableColumn
                        [style]="{'width': '15%'}" styleClass="text-center"></p-column>
              <p-column field="amount" header="Amount" pResizableColumn [style]="{'width': '15%'}"
                        styleClass="text-center">
                <ng-template let-row="rowData" pTemplate="body">
                  {{row.amount | number :'1.2-2'}}
                </ng-template>
              </p-column>
              <p-column header="" [style]="{'width': '10%'}" *ngIf="canModifyOrderTransactionLine()">
                <ng-template let-row="rowData" pTemplate="body">
                  <div [ngClass]="['text-center']">
                    <span class="modify-transaction-line-ctrl"
                          (click)="modifyOrderTransactionLine(row.id)">Modify</span>
                  </div>
                </ng-template>
              </p-column>
            </p-dataTable>

            --->

            <div align="right" class="summary-div">
              <span>Total: £{{ total(enginieusOrderPrices) }}</span>
            </div>
          </div>
        </p-card>
      </div>
    </div>
  </div>

  <p-dialog
    header="Price Details"
    [(visible)]="isAddJoborOrderDlg"
    [responsive]="true"
    [modal]="true"
    [style]="{ width: '410px' }"
    (onHide)="close()"
  >
    <div style="position: relative; height: 260px">
      <div class="ui-g-12">
        <div *ngIf="isAddJob">
          <div class="ui-grid-col-4">
            <label>Account Code</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="jobCodes"
              autoWidth="false"
              name="jobCodes"
              [style]="{ width: '100%' }"
              [(ngModel)]="price.accountCode"
            ></p-dropdown>
          </div>
        </div>

        <div *ngIf="isAddOrder" class="ui-grid-row">
          <div class="ui-grid-row">
            <div class="ui-grid-col-4">
              <label>Cost Code</label>
            </div>
            <div class="ui-grid-col-8">
              <p-dropdown
                [options]="orderCodes"
                autoWidth="false"
                name="orderCodes"
                [style]="{ width: '100%' }"
                [(ngModel)]="price.accountCode"
              ></p-dropdown>
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-grid-row">
            <div class="ui-grid-col-4">
              <label>Order Number</label>
            </div>
            <div class="ui-grid-col-8">
              <p-dropdown
                [options]="orderNumbersSelectItem"
                autoWidth="false"
                name="orderNumber"
                [style]="{ width: '100%' }"
                [(ngModel)]="price.orderId"
                (onChange)="onOrderChange()"
              ></p-dropdown>
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-grid-row">
            <div class="ui-grid-col-4">
              <label>Task</label>
            </div>
            <div class="ui-grid-col-8">
              <p-dropdown
                [options]="vehicleRegistrationsSelectItem"
                autoWidth="false"
                name="vehicleRegistration"
                [style]="{ width: '100%' }"
                (onChange)="onTaskChange()"
                [(ngModel)]="price.taskId"
              ></p-dropdown>
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-grid-row">
            <div class="ui-grid-col-4">
              <label>Transaction Category</label>
            </div>
            <div class="ui-grid-col-8">
              <p-dropdown
                [options]="transactionCategorySelectItems"
                autoWidth="false"
                name="transactionCategory"
                [style]="{ width: '100%' }"
                [(ngModel)]="transactionCategoryItem"
                (onChange)="onTransactionCategoryChange($event)"
              ></p-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label for="description">Description</label>
        </div>
        <div class="ui-grid-col-8">
          <textarea
            pInputTextarea
            id="description"
            rows="6"
            cols="12"
            [ngClass]="['ui-g-12']"
            name="description"
            [(ngModel)]="price.description"
            [autoResize]="true"
            (keydown.enter)="$event.stopPropagation(); (false)"
            (keydown.tab)="$event.stopPropagation(); (false)"
          ></textarea>
        </div>
      </div>

      <div *ngIf="isAddOrder" class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Purchase Order No</label>
        </div>
        <div class="ui-grid-col-8">
          <input
            name="purchaseOrderNumber"
            maxlength="20"
            pInputText
            style="width: 100%"
            [(ngModel)]="price.purchaseOrderNumber"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Amount (£)</label>
        </div>
        <div class="ui-grid-col-8">
          <!--<p-spinner [(ngModel)]="price.amount" [style]="{'width': '100%'}" [step]="0.1"></p-spinner>-->
          <input
            [(ngModel)]="price.amount"
            [style]="{ width: '100%' }"
            pInputText
            maxlength="10"
            (keydown)="inputHelper.allowNumberInputKey($event)"
            (keyup)="inputHelper.fixDigits($event.target)"
          />
        </div>
      </div>

      <div class="ui-g-12" style="width: 100%; height: 40px; margin-top: 10px">
        <button
          type="button"
          (click)="close()"
          pButton
          icon="fa ui-icon-close"
          label="Cancel"
          class="ui-button btn-to-right"
        ></button>
        <button
          type="button"
          pButton
          icon="fa ui-icon-check"
          label="Save"
          class="ui-button green-btn btn-to-right"
          (click)="save(price)"
          [disabled]="!price.description || !price.amount || isUpdatingPriceDetails"
        ></button>
      </div>
    </div>
  </p-dialog>
</div>
